import { notification } from "antd";
import axios from "axios"

const BUCKET = process.env.REACT_APP_BUCKET
const url = process.env.REACT_APP_URL

const getSignedUrl = async (path: string) => {
  try {
    const data = await axios.get(url + "/aws/getSignedUrl", {
      params: {
        path: path
      }
    })
    if (data.data)
      return data?.data.signedUrl
  } catch (err) {
    return null
  }
}

// Upload de la photo en passant par le backend au lieu d'une presigned url: le PUT direct
// du navigateur vers *.s3.amazonaws.com est bloque par les politiques CASB (Netskope) de
// certains clients. Active via le parametre avance "Envoi des photos via le serveur".
const uploadThroughBackend = async (path: string, image: Blob) => {
  await axios.post(url + "/aws/uploadScanImage", image, {
    params: { path: path },
    headers: { "Content-Type": "image/jpeg" }
  })
}

const uploadWithSignedUrl = async (path: string, image: Blob) => {
  const file = new File([image], "testfile")
  const signedUrl = await getSignedUrl(path)
  if (signedUrl) {
    await fetch(signedUrl, {
      method: "PUT",
      body: file,
      headers: {
        "Content-Type": 'multipart/form-data'
      }
    })
  }
}

export const getExtractedData = async (image: Blob, bpId: string, trayId: string, isPhotoOnly: boolean, qrValue: string | undefined,
  uploadViaBackend?: boolean) => {
  var path = bpId + "/" + trayId + '.jpeg'

  sessionStorage.removeItem("result")
  const isTest = localStorage.getItem("isTest")
  if (isTest === 'true') {
    // Test mode: use a known test image path, skip S3 upload
    path = "798714655/55ee949d-f60c-48c9-b9f4-03530c11fc63.jpeg"
  } else {
    try {
      if (uploadViaBackend)
        await uploadThroughBackend(path, image)
      else
        await uploadWithSignedUrl(path, image)
    } catch (err) {
      console.log(err)
      // Sans l'image dans le bucket l'appel modele echouera de toute facon: on remonte
      // l'erreur ici plutot que de laisser croire a un resultat vide.
      notification.error({ message: "L'envoi de la photo a échoué. Veuillez relancer le scan. En cas d'erreur répétée veuillez contacter le support Datakeen et utiliser le mode photo seule." })
      return []
    }
  }

  if (isPhotoOnly) return ""
  try {
    const res = await axios.post(url + '/scan/extractedData', { file: `s3://${BUCKET}/${path}`, path: path, trayId: qrValue })
    sessionStorage.setItem("image", path)
    return { data: res, uuid: trayId }
  } catch (err) {
    notification.error({ message: "Erreur serveur. Veuillez relancer le scan. En cas d'erreur répétée veuillez contacter le support Datakeen et utiliser le mode photo seule." })
    return []
  }
}